import "styled-components";
import defaultTheme from "./default-theme";

const ornamentTheme = {
  ...defaultTheme,
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/ornament.png") repeat top center, 
    radial-gradient(circle, #163834, #112c29);`, //спросить
  },
  header: {
    fontColor: "#f9e9d5",
    background: `linear-gradient(to right, transparent, 	rgba(129,123,77, 0.6), transparent)`,
  },
  main: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/ornament-line.png") no-repeat top center,
    #163834;`,

    fontsColor: {
      name: "#fdfdfd",
      label: "#e4cfb3",
      text: "#ceab7d",
      border: " #817B4D",
    },
  },
  footer: {
    fontColor: "#ddd5c2",
  },
};

export default ornamentTheme;
